const now = () => {
    return +new Date();
};
export default now;
